"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InCallStreemshots = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const room_session_1 = require("../../../context/room_session");
const ui_react_1 = require("@streem/ui-react");
const rxjs_1 = require("../../../hooks/rxjs");
const domain_id_1 = require("@streem/domain-id");
const model_serial_feedback_1 = require("./model_serial_list/model_serial_feedback");
const company_settings_1 = require("../../../context/company_settings");
const InCallStreemshots = () => {
    const roomSession = (0, room_session_1.useRoomSession)();
    const [streemshots] = (0, rxjs_1.useObservable)(roomSession.streemshots.responses);
    const roomSessionDetections = (0, room_session_1.useRoomSessionDetections)();
    const companySettings = (0, company_settings_1.useCompanySettings)();
    return ((0, jsx_runtime_1.jsx)(StreemshotListWrapper, { children: streemshots &&
            streemshots.map((streemshot, index) => {
                const detectionsForStreemshot = roomSessionDetections.filter(detection => {
                    // See comment on revisions in model_serial_list.tsx, near here:
                    //      https://github.com/streem/streem-app/blob/main/web/packages/sdk-react/src/components/in_call/spectator/model_serial_list/model_serial_list.tsx#L37
                    return (detection.streemshotSid === streemshot.streemshotId ||
                        detection.streemshotSid === streemshot.id);
                });
                return ((0, jsx_runtime_1.jsx)(Streemshot, { id: new domain_id_1.StreemshotId((streemshot === null || streemshot === void 0 ? void 0 : streemshot.streemshotId) || streemshot.id), streemshot: streemshot, detections: detectionsForStreemshot, dataTestId: 'streemshot ' + index.toString(), noteCharacterLimit: companySettings === null || companySettings === void 0 ? void 0 : companySettings.streemshotNoteCharLimit }, streemshot.id));
            }) }));
};
exports.InCallStreemshots = InCallStreemshots;
function Streemshot({ id, streemshot, dataTestId, detections, noteCharacterLimit = 225, }) {
    var _a;
    const roomSession = (0, room_session_1.useRoomSession)();
    const [streemshotNote] = (0, rxjs_1.useObservable)(roomSession.note.getStreemshotNote(id));
    const [errorMessage, setErrorMessage] = (0, react_1.useState)('');
    if (!streemshot.downloadUrl) {
        return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
    }
    return ((0, jsx_runtime_1.jsxs)(StreemshotWithNotesWrapper, { children: [(0, jsx_runtime_1.jsx)(StreemshotImage, { onClick: () => {
                    window.open(streemshot.downloadUrl, '_blank', 'noopener,noreferrer');
                }, src: streemshot.downloadUrl, "data-testid": dataTestId }), (0, jsx_runtime_1.jsx)(ModelSerialWrapper, { children: (0, jsx_runtime_1.jsx)(model_serial_feedback_1.ModelSerialFeedback, { modelSerialDetections: detections, onAdd: (description, type) => {
                        roomSession.detections.createDetection(id, description, type);
                    }, onEdit: (detectionId, newDetection) => {
                        if (typeof (newDetection === null || newDetection === void 0 ? void 0 : newDetection.description) === 'string' && newDetection.type) {
                            roomSession.detections.updateDetection(detectionId, newDetection === null || newDetection === void 0 ? void 0 : newDetection.description, newDetection === null || newDetection === void 0 ? void 0 : newDetection.type);
                        }
                    }, onDelete: detectionId => {
                        roomSession.detections.deleteDetection(detectionId);
                    } }) }), (0, jsx_runtime_1.jsx)(ui_react_1.EditableNote, { testId: "artifact-notes", hasFootBar: false, description: "", placeholderText: 'Add notes', characterLimit: noteCharacterLimit, noteText: (_a = streemshotNote === null || streemshotNote === void 0 ? void 0 : streemshotNote.text) !== null && _a !== void 0 ? _a : '', errorMessage: errorMessage, onSave: (noteText) => __awaiter(this, void 0, void 0, function* () {
                    try {
                        setErrorMessage('');
                        yield roomSession.note.saveStreemshotNote(id, noteText);
                    }
                    catch (error) {
                        setErrorMessage('Error attempting to edit notes.');
                    }
                }) })] }, `streemshot-${streemshot.downloadUrl}`));
}
const StreemshotListWrapper = ui_react_1.styled.div({
    display: 'flex',
    flexDirection: 'column',
    marginTop: '16px',
    marginBottom: '16px',
});
const ModelSerialWrapper = ui_react_1.styled.div({
    marginTop: '16px',
    paddingBottom: '12px',
});
const StreemshotWithNotesWrapper = ui_react_1.styled.div(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    marginBottom: theme.spacing.l,
}));
const StreemshotImage = ui_react_1.styled.img(({ theme }) => ({
    // TODO: Use css aspect-ratio once widely supported
    // https://caniuse.com/mdn-css_properties_aspect-ratio
    height: 227.25,
    marginBottom: theme.spacing.s,
    backgroundColor: theme.colors.grey90,
    objectFit: 'contain',
    cursor: 'pointer',
    border: `1px solid ${theme.colors.grey20}`,
    '&:hover': {
        filter: 'brightness(0.9)',
    },
}));
//# sourceMappingURL=in_call_streemshots.js.map